'use client';
import { jsx } from 'react/jsx-runtime';
import { defineStyle } from '@chakra-ui/styled-system';
import { AnimatePresence } from 'framer-motion';
import { useTooltipStyles, useTooltipContext } from './tooltip-context.mjs';
import { Portal } from '../portal/portal.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { chakra } from '../system/factory.mjs';

const TooltipPositioner = forwardRef(
  function TooltipPositioner2(props, ref) {
    const { portalProps, ...restProps } = props;
    const styles = useTooltipStyles();
    const api = useTooltipContext();
    const positionerStyles = defineStyle({
      zIndex: styles.zIndex,
      pointerEvents: "none"
    });
    return /* @__PURE__ */ jsx(AnimatePresence, { children: api.isOpen && /* @__PURE__ */ jsx(Portal, { ...portalProps, children: /* @__PURE__ */ jsx(
      chakra.div,
      {
        ...api.getPositionerProps(restProps, ref),
        className: "chakra-tooltip__positioner",
        __css: positionerStyles
      }
    ) }) });
  }
);
TooltipPositioner.displayName = "TooltipPositioner";

export { TooltipPositioner };
